@if (form.view) {
    <form class="w-100" (ngSubmit)="submit()">
        <sf-form
            name="row-1"
            (ngModelChange)="onModelChanged($event)"
            [view]="form.view"
            class="col-12"
            rowClasses="col-12"
            [(ngModel)]="form.model"
            [fields]="['name']"
        >
        </sf-form>

        <div class="col-12 mb-2">
            <label class="form-label">Find the location</label>
            <div class="input-group">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Search a place or address (e.g. Yuendumu)"
                    [(ngModel)]="searchQuery"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown.enter)="$event.preventDefault(); search()"
                />
                <button type="button" class="btn btn-secondary" (click)="search()"><i class="fa fa-search"></i></button>
                <button type="button" class="btn btn-outline-secondary" (click)="useMyLocation()">
                    <i class="fa fa-location-crosshairs me-1"></i> My location
                </button>
            </div>
            @if (searchError) {
                <small class="text-danger d-block mt-1">{{ searchError }}</small>
            }
            <small class="text-muted d-block mt-1">Then click the map (or drag the pin) to set the exact spot.</small>
        </div>

        <div class="col-12 mb-3">
            <div #mapEl id="checkInLocationMap"></div>
        </div>

        <div class="col-12 mb-3">
            @if (hasCoords()) {
                <span class="badge bg-light text-dark border">
                    <i class="fa fa-map-marker-alt me-1"></i>
                    {{ form.model.latitude | number: '1.5-5' }}, {{ form.model.longitude | number: '1.5-5' }}
                </span>
            } @else {
                <span class="text-muted">No location selected yet — search, use your location, or click the map.</span>
            }
        </div>

        <div class="pe-4">
            <button type="submit" class="flex-shrink-1 btn btn-success ms-auto d-flex align-items-center" [disabled]="!hasCoords()">
                <i class="fa fa-fw fa-save mb-0 me-1"></i> Save
            </button>
            <hr />
        </div>
    </form>
} @else {
    @if (form.error) {
        <small class="text-danger">Error loading form</small>
    } @else {
        <small class="text-muted">Loading...</small>
    }
}
